// extracted by mini-css-extract-plugin
export default {"brandPromo":"nG-z","carousel":"oG-z"};